<template>
    <section class="overflow-hidden bg-blue-100 self-gutter-y">
        <div class="self-gutter">
            <div class="self-content">
                <div class="flex items-center justify-between">
                    <h2 class="pr-12 title-2xl">{{ title }}</h2>

                    <a :href="$t('all_offers_link').toString()" class="self-btn-plain">
                        <span class="self-btn-plain__text">{{ $t('dashboard.all') }}</span>
                        <span class="self-btn-plain__icon"><IconArrowAlt/></span>
                    </a>
                </div>
                <!-- OFFERS -->
                <div class="relative pt-24 swiper-container self-offers-slider sm:pt-48">
                    <ul class="swiper-wrapper" v-html="webContent">
                    </ul>
                    <div class="flex items-center justify-between flex-1 pt-24">
                        <div>
                            <div class="swiper-pagination self-offers-slider-pagination"></div>
                        </div>
                        <div class="flex">
                            <button class="mr-4 self-offer-slider-nav self-offers-slider-prev">
                                <span class="flex-shrink-0 block w-20 h-20 text-black transform rotate-180 fill-current">
                                    <IconArrowForward/>
                                </span>
                            </button>

                            <button class="ml-4 self-offer-slider-nav self-offers-slider-next">
                                <span class="flex-shrink-0 block w-20 h-20 text-black fill-current">
                                    <IconArrowForward/>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import IconArrowAlt from '@/assets/static/icons-src/icon-arrow-alt.svg'
import IconArrowForward from '@/assets/static/icons-src/icon-arrow-forward.svg'
import { initOffersSlider } from '@/scripts/sliders'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
    components: {
        IconArrowAlt,
        IconArrowForward
    }
})
export default class BestOffersBlock extends Vue {
    @Prop(String) readonly webContent!: string;
    @Prop(String) readonly title!: string;
    mounted() {
        // Wait for the next tick to ensure v-html content is loaded
        this.$nextTick(() => {
            initOffersSlider();
        });
    }
}
</script>

<style scoped>

</style>
